import { Wrapper } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const WithHighlight: FunctionComponent<Props> = ({
    children,
    className = '',
    isEnabled = true,
    testId = TEST_ID
}) => {
    const disabledClass = !isEnabled ? styles.disabled : '';

    return (
        <Wrapper
            className={`${className} ${disabledClass} ${styles.withHighlight}`}
            testId={testId}>
            {children}
        </Wrapper>
    );
};

export default WithHighlight;
